import http from '@/utils/http';
const base_path = '/v2/tool/label';

/**
 * 获取标签列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getLabelListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
